import * as React from 'react';
import { withRouter } from 'react-router';
import { useParams, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import RolePage from './RolePage';
import { getAreas } from '../../redux/selectors/areas';
import { RolesState } from '../../redux/configure-store';
import { useQuery } from '../../services/locationService';
import { useEffect } from 'react';
import { reportViewOrEditRoleLoad } from '../../redux/actions/bi.actions';

const getRoleById = (roles = [], id = '') => roles.filter(({ id: roleId }) => id === roleId)[0] || {};

export const NewRolePage = withRouter(({ match: { path } }) => {
    const location = useLocation();
    const id = useQuery(location).get('duplicateId');
    return <RolePageContainer roleParams={{ id , editRole: true, newRole: true, isCustom: true }} path={path} />;
});

export const ViewRolePage = withRouter(({ match: { path } }) => {
    const dispatch = useDispatch();
    const location = useLocation<any>();
    const { id } = useParams();

    useEffect(() => {
        dispatch(reportViewOrEditRoleLoad('view', location?.state?.origin, id));
    }, [location]);

    return <RolePageContainer roleParams={{ id }} path={path} />;
});

export const EditRolePage = withRouter(({ match: { path } }) => {
    const dispatch = useDispatch();
    const location = useLocation<any>();
    const { id } = useParams();

    useEffect(() => {
        dispatch(reportViewOrEditRoleLoad('edit', location?.state?.origin, id));
    }, [location]);

    return <RolePageContainer roleParams={{ id, editRole: true }} path={path} />;
});

export const RolePageContainer = ({ path, roleParams }) => {
    const areas = useSelector(getAreas);

    const { role, rolesList } = useSelector(({ roles = [] }: { roles: RolesState }) => {
        let { scopes = [], title, description, isCustom } = getRoleById(roles, roleParams.id);
        let duplicateTitle;
        if (roleParams.id && roleParams.newRole && title) {
           duplicateTitle = title;
        }
        return {
            role: {
                selectedScopes: scopes,
                title: roleParams.title || title,
                description: roleParams.description || description,
                isCustom: roleParams.isCustom || isCustom,
                id: roleParams.newRole ? undefined : roleParams.id,
                duplicateTitle,
            },
            rolesList: roles
        };
    });

    return <RolePage {...role} areas={areas} path={path} edit={roleParams.editRole} roles={rolesList}/>;
};
